import React from 'react';
import { useIntl } from 'umi';
import { Segment } from 'tea-component';
import { addFormatMessageSafelyHandler } from '../../utils';

const getOptions = (options: any[], cfg: { isTranslate: boolean; translater: Function }): any[] => {
  if (!Array.isArray(options)) return [];
  const { isTranslate, translater } = cfg ?? {};
  if (!isTranslate) return options;
  return options.map((opt: any) => {
    const translateKey = opt?.text;
    return {
      ...opt,
      text: translater({ id: translateKey }),
    };
  });
};

export default function GenreSegment(props: any) {
  const { isTranslate = true, value, onChange, opts: optsOuter, customClassname } = props;

  const { formatMessage } = useIntl();
  const formatMessageSafely = addFormatMessageSafelyHandler(formatMessage);

  const opts = getOptions(optsOuter, { isTranslate, translater: formatMessageSafely });

  return (
    <Segment
      key="genre"
      className={`${customClassname}`}
      value={value}
      onChange={(payload: any) => {
        if (payload === value) return;
        onChange(payload);
      }}
      options={opts ?? []}
    />
  );
}
